import axios from 'axios';

//const apiBaseUrl = 'http://localhost:3001';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const fetchData = async (url, method, data = null) => {
    try {
        const response = await axios({ url: `${apiBaseUrl}/${url}`, method, data });
        return response.data;
    } catch (error) {
        console.error(`Error ${method} ${url}:`, error);
        throw error;
    }
};

const createNews = async (newsData) => fetchData('api/teacher/submitnews', 'POST', newsData);

const clearNewsStatus = async (id) => fetchData('api/teacher/clearnewsstatus', 'POST', { id });

const updateStatus = async (id, status) => fetchData(`api/teacher/updatestatus/${id}`, 'POST', { status });

const fetchNews = async () => fetchData('api/teacher/news', 'GET');

const fetchNewsById = async (newsId) => fetchData(`api/news/${newsId}`, 'GET');

const fetchNewsStatusById = async (newsId) => fetchData(`api/news/status/${newsId}`, 'GET');

const updateNewsComment = async (newsId, comment) => fetchData(`api/news/comment/${newsId}`, 'PATCH', { comment });

const deleteNews = async (newsId) => fetchData(`api/news/${newsId}`, 'DELETE');

export {
    createNews,
    clearNewsStatus,
    updateStatus,
    fetchNews,
    fetchNewsById,
    fetchNewsStatusById,
    updateNewsComment,
    deleteNews,
};
